const apiVersion = '/api/v1';

export default ($axios) => ({
    index() {
        return $axios.$get(`${apiVersion}/hotmatch`, {
            progress: false
        });
    }
});
